var jarallax = require('./src/jarallax.esm').default;

var _jarallaxVideo = require('./src/jarallax-video.esm').default;

var _jarallaxElement = require('./src/jarallax-element.esm').default;

module.exports = {
  jarallax: jarallax,
  jarallaxElement: function jarallaxElement() {
    return _jarallaxElement(jarallax);
  },
  jarallaxVideo: function jarallaxVideo() {
    return _jarallaxVideo(jarallax);
  }
};